var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEntrance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32695 7C5.32695 6.78581 5.50059 6.61217 5.71478 6.61217H5.71517C5.92936 6.61217 6.10299 6.78581 6.10299 7C6.10299 7.21419 5.92936 7.38782 5.71517 7.38782H5.71478C5.50059 7.38782 5.32695 7.21419 5.32695 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1561 3.04983C6.9026 2.82588 7.65391 3.38487 7.65391 4.16424V9.83574C7.65391 10.6151 6.90261 11.1741 6.1561 10.9502L3.82915 10.2521C3.33703 10.1044 3 9.65148 3 9.13765V4.86232C3 4.34852 3.33702 3.89556 3.82915 3.74792L6.1561 3.04983ZM6.87825 4.16424C6.87825 3.90445 6.62781 3.71812 6.37899 3.79277L4.05203 4.49086C3.88799 4.54007 3.77565 4.69106 3.77565 4.86232V9.13765C3.77565 9.30895 3.88799 9.45992 4.05204 9.50914L6.37899 10.2072C6.62779 10.2819 6.87825 10.0956 6.87825 9.83574V4.16424Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04173 3.89739C8.04173 3.6832 8.21537 3.50957 8.42956 3.50957H9.59303C10.2356 3.50957 10.7565 4.03048 10.7565 4.67304V5.06087C10.7565 5.27506 10.5829 5.44869 10.3687 5.44869C10.1545 5.44869 9.98086 5.27506 9.98086 5.06087V4.67304C9.98086 4.45885 9.80723 4.28522 9.59303 4.28522H8.42956C8.21537 4.28522 8.04173 4.11158 8.04173 3.89739Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3687 8.5513C10.5829 8.5513 10.7565 8.72493 10.7565 8.93912V9.32695C10.7565 9.96953 10.2356 10.4904 9.59303 10.4904H8.42956C8.21537 10.4904 8.04173 10.3168 8.04173 10.1026C8.04173 9.88841 8.21537 9.71477 8.42956 9.71477H9.59303C9.80723 9.71477 9.98086 9.54115 9.98086 9.32695V8.93912C9.98086 8.72493 10.1545 8.5513 10.3687 8.5513Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47944 6.49858C9.6309 6.34712 9.6309 6.10156 9.47944 5.95011C9.32799 5.79865 9.08243 5.79865 8.93097 5.95011L8.15532 6.72576C8.00387 6.87722 8.00387 7.12277 8.15532 7.27423L8.93097 8.04988C9.08243 8.20133 9.32799 8.20133 9.47944 8.04988C9.6309 7.89842 9.6309 7.65287 9.47944 7.50141L9.36585 7.38782H10.3687C10.5829 7.38782 10.7565 7.21418 10.7565 6.99999C10.7565 6.7858 10.5829 6.61217 10.3687 6.61217H9.36585L9.47944 6.49858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntrance);
export default __webpack_public_path__ + "static/media/icon-entrance.954055c6d6f3132dbf5ec1d5816328b1.svg";
export { ForwardRef as ReactComponent };